export interface User {
  id: number;
  email: string;
  emailNotifications: boolean;
  username: string;
  firstName?: string;
  lastName?: string;
  featureFlags: string[];
  impersonating: ImpersonatingInfo | null;
  settings?: {
    [key: string]: any;
  };
  isStaff?: boolean;
  language: string;
  company_name?: string;
  // backend/cavela/serializers.py > AuthenticatedUserRequestSerializer.get_timezone
  // IANA timezone name; absent for users who never recorded one.
  timezone?: string;
  addresses?: Address[];
  avatar?: string;
  organizations?: Organization[];
  banner_message?: string;
}

export interface Address {
  name: string;
  line_1: string;
  line_2?: string;
  city: string;
  state: string;
  zip_code: string;
  country: string;
  contact_name: string;
  contact_phone: string;
  contact_email?: string;
  is_default?: boolean;
}

export interface ImpersonatingInfo {
  id: string;
  username: string;
}

export interface Organization {
  id: number;
  name: string;
  role: OrganizationRole;
  avatar: string;
  addresses?: Address[];
  members: OrganizationMember[];
  discounts?: string[];
  archived?: boolean;
}

export enum OrganizationRole {
  ADMIN = 'admin',
  MEMBER = 'member'
}

export interface OrganizationMember {
  id: number;
  username: string;
  email: string;
  avatar_url: string | null;
  role: OrganizationRole;
  /** ISO date the user's account was created. */
  date_joined: string;
  /** ISO date of the user's last log in, null if they never logged in. */
  last_login: string | null;
}
